import { arcgisToGeoJSON } from "@esri/arcgis-to-geojson-utils";

import CountryPolygons from "../Map/CountryPolygons";
import SanctionAuthority from "../Sanctions/SanctionAuthority";
import BaseModel from "./BaseModel";

const SanctionDataMappings = {
	[SanctionAuthority.OFAC]: {
		title: "properties.Title",
		description: "properties.Description",
		date: "properties.EditDate",
		url: "properties.Link",
		country: "properties.Country",
		countryCode: "properties.ADM0_A2"
	},
	[SanctionAuthority.EU]: {
		title: "properties.EUUN_Specification_Type",
		description: "properties.EUUN_RestrictiveMeasures_10k",
		date: "properties.EditDate",
		url: "properties.EUUN_List",
		country: "properties.EUUN_Country_Category",
		countryCode: "properties.ADM0_A2"
	},
	[SanctionAuthority.UN]: {
		title: "properties.EUUN_Specification_Type",
		description: "properties.EUUN_RestrictiveMeasures_10k",
		date: "properties.EditDate",
		url: "properties.EUUN_List",
		country: "properties.EUUN_Country_Category",
		countryCode: "properties.ADM0_A2"
	},
	[SanctionAuthority.US]: {
		title: "properties.US_ActiveSanctionsPrograms_Title",
		date: "properties.EditDate",
		url: "properties.US_ActiveSanctionsPrograms_Link",
		countryCode: "properties.ADM0_A2"
	}
};
class Sanction extends BaseModel {
	constructor(arcgisFeatureData, sanctionAuthority) {
		super(SanctionDataMappings[sanctionAuthority], {
			title: "Unknown",
			description: "N/A",
			country: "",
			countryCode: "",
			date: 0
		});

		this.arcgisData = arcgisFeatureData;
		this.geojsonData = arcgisToGeoJSON(this.arcgisData);
		this.data = this.geojsonData;

		this.authority = sanctionAuthority;

		if (this.authority === SanctionAuthority.OFAC ||
			 this.authority === SanctionAuthority.EU ||
			 this.authority === SanctionAuthority.UN ||
			 this.authority === SanctionAuthority.US) {
			this._lng = 0;
			this._lat = 0;
			const feature = CountryPolygons.getCountryFeature(this.countryCode);
		}
		else {
			console.warn("Unknown Sanction Authority", this.authority);
		}

		if (this.data.geometry && this.data.geometry.type === "Point") {
			this.data.geometry.coordinates[0] = this.lng;
			this.data.geometry.coordinates[1] = this.lat;
		}
	}

	get title() {
		return this.get("title");
	}

	get description() {
		return this.get("description");
	}

	get url() {
		return this.get("url");
	}

	get date() {
		return this.get("date");
	}

	get readableAuthority() {
		if (this.authority === SanctionAuthority.OFAC) {
			return "OFAC Update";
		}
		return this.authority;
	}

	get readableDate() {
		if (this.get("date") === 0) {
			return "Unknown";
		}
		return new Date(this.get("date")).toLocaleDateString();
	}

	get country() {
		return CountryPolygons.getCountryFeature(this.countryCode).properties.name; // this.get("country");
	}

	get countryCode() {
		return this.get("countryCode");
	}

	get lng() {
		return this._lng;
	}

	get lat() {
		return this._lat;
	}

	asFeature() {
		return this.data;
	}
}

export default Sanction;
